import { css } from '@emotion/css'
import { spacing, borderRadius, fontSize, fontWeight, fontFamily, shorthandHelper, hexToRgba } from '@offerzen/pinata-shame'

import colors from '../../lib/themes/colors'

const styles = {
  container: css({
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    backgroundColor: colors.white,
  }),

  button: css({
    display: 'block',
    textDecoration: 'none',
    cursor: 'pointer',
    textAlign: 'center',
    width: '50%',
    lineHeight: 1,
    padding: shorthandHelper([spacing.medium, spacing.small]),
    background: colors.mystic,
    color: colors.scorpion,
    fontSize: fontSize.default,
    fontWeight: fontWeight.regular,
    fontFamily: fontFamily.body,
    borderBottomLeftRadius: borderRadius.default,
    borderTopLeftRadius: borderRadius.default,
    borderLeft: `1px solid ${hexToRgba(colors.darkEclipse, 0.1)}`,
    borderBottom: `1px solid ${hexToRgba(colors.darkEclipse, 0.1)}`,

    '&:hover': {
      background: colors.mystic,
      textDecoration: 'none',
    },
  }),

  active: css({
    background: 'white',
    color: colors.cornflowerBlue,
    fontWeight: fontWeight.semiBold,
    borderRadius: 0,
    border: 0,
  }),
}

export default styles
